import type { Report } from '@/data/schemas';
import { StatusChip } from './chip';

interface ReportStatusBadgeProps {
  status: Report['status'];
  className?: string;
}

export function ReportStatusBadge({ status, className }: ReportStatusBadgeProps) {
  return <StatusChip status={status} showIcon className={className} />;
}
